// PREDICTIONS URL'S
export const urlRounds = 'https://api.s-bobet.com/wp-json/joomsport_prediction_api/v1/leagues';
export const urlLeaderBoard = 'https://api.s-bobet.com/wp-json/joomsport_prediction_api/v1/leaderboard/';
export const urlHistory = 'https://api.s-bobet.com/wp-json/joomsport_prediction_api/v1/history/';
